import { render, staticRenderFns } from "./RemoteModal.vue?vue&type=template&id=1b7073e3&scoped=true"
import script from "./RemoteModal.vue?vue&type=script&lang=js"
export * from "./RemoteModal.vue?vue&type=script&lang=js"
import style0 from "./RemoteModal.vue?vue&type=style&index=0&id=1b7073e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7073e3",
  null
  
)

export default component.exports